var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ConfirmationModal',{attrs:{"cancelText":"cancel","continueText":"create","enableMainAction":_vm.enableMainAction,"handleCancel":_vm.handleCancel,"handleContinue":_vm.handleContinue,"headerText":"Create New Active Directory Domain","mdTemplate":_vm.mdTemplate}},[_c('InputValidator',{attrs:{"config":{
      label: 'Domain Name',
      name: _vm.inputName,
      validate: 'required|adDomainNameValidation',
      value: _vm.domain,
    }},on:{"InputValidatorModel":_vm.handleValueChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }